module.exports = __webpack_public_path__ + "static/media/whisky_distillery_mobile.cf0bb26b.jpg";